<h2 mat-dialog-title>Solicitar periodo de horas extra</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="flex flex-col gap-4 pt-4">
    <mat-form-field appearance="outline">
      <mat-label>Periodo</mat-label>
      <mat-date-range-input [rangePicker]="picker" [min]="minDate">
        <input matStartDate formControlName="start_date" placeholder="Fecha inicio" />
        <input matEndDate formControlName="end_date" placeholder="Fecha fin" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <div class="flex gap-4 items-center">
      <mat-form-field appearance="outline" class="flex-1">
        <mat-label>Horas semanales máx. (opcional)</mat-label>
        <input matInput type="number" formControlName="max_weekly_hours" />
      </mat-form-field>

      <div class="flex-1">
        <mat-checkbox formControlName="is_remote_working_allowed">Permitido teletrabajo</mat-checkbox>
      </div>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>
        @if (requiresAtLeastOneCompanyProduct()) {
          Productos
        } @else {
          Productos (opcional)
        }
      </mat-label>
      <mat-select formControlName="company_product_ids" multiple>
        @for (p of company_products(); track p.id) {
          <mat-option [value]="p.id">{{ p.title }}</mat-option>
        }
      </mat-select>
      @if (requiresAtLeastOneCompanyProduct()) {
        <mat-hint>Obligatorio: indica al menos un producto.</mat-hint>
      } @else {
        <mat-hint>Opcional. Déjalo vacío si no trabajas en un producto concreto (p. ej. administración).</mat-hint>
      }
      @if (form.controls['company_product_ids'].hasError('required') && form.controls['company_product_ids'].touched) {
        <mat-error>Debes seleccionar al menos un producto</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Justificación</mat-label>
      <textarea matInput formControlName="justification" rows="4"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" (click)="save()" [disabled]="form.invalid || saving()">
    @if (saving()) {
      Solicitando…
    } @else {
      Solicitar
    }
  </button>
</mat-dialog-actions>
